<template>
  <div>
    <v-container fluid class="fill-height">
      <v-card :height="height" width="100%" class="overflow-y-auto">
        <slot></slot>
      </v-card>
      <slot name="toolbar">
        <v-toolbar
            dense
            class="mx-0 mt-0"
            no-gutters
            bottom
        >
          <slot name="footer"></slot>
        </v-toolbar>
      </slot>
    </v-container>
  </div>
</template>

<script>

export default {
  name: 'BaseSheet',
  props: {
    isDialog: {type: Boolean, default: false},
  },

  components: {},

  computed: {},

  methods: {},

  mounted() {
    if (this.isDialog)
      this.height = this.$vuetify.breakpoint.height - 170
    else
      this.height = this.$vuetify.breakpoint.height - 105
  },
  created() {
  },
  destroyed() {
  },

  data() {
    return {
      height: null,
    }
  },
}
</script>

<style scoped lang="scss">
</style>
